import { render, staticRenderFns } from "./mncmcc.vue?vue&type=template&id=a6e1daa4&scoped=true&"
import script from "./mncmcc.vue?vue&type=script&lang=js&"
export * from "./mncmcc.vue?vue&type=script&lang=js&"
import style0 from "./mncmcc.vue?vue&type=style&index=0&id=a6e1daa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e1daa4",
  null
  
)

export default component.exports